import { getResult } from 'helpers/request';
import { requestServices } from 'repos';

const { locationService } = requestServices;

/**
 * find all transaction
 * @param {object} params
 * @returns {Promise<AxiosResponse<T>>}
 */
const findAllProvinces = () => {
  return locationService.get('/location/provinces').then(getResult);
};

export const findAllDistricts = async (provinceCode: number | string) => {
  return locationService
    .get('/location/districtWithWards', {
      params: { provinceCode: provinceCode },
    })
    .then(getResult);
};

export default { findAllProvinces, findAllDistricts };
